module.exports = __webpack_public_path__ + "img/unicef.dd6436e7.png";